import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'src/app/components/components.module';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { VehicleNicknamePage } from './vehicle-nickname.page';
import { VehicleNicknamePageRoutingModule } from './vehicle-nickname-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VehicleNicknamePageRoutingModule,
    ComponentsModule,
  ],
  declarations: [VehicleNicknamePage],
})
export class VehicleNicknamePageModule {}
